module.exports = __webpack_public_path__ + "img/scene2-5.6ce3e315.jpg";